module.exports = __webpack_public_path__ + "img/box7-6.dc1852ab.png";